import React, { useContext, useEffect, useState } from 'react';

import { RestApiContext } from './RestApiContext';
import { useAggregatedState } from '../../helpers';

export const UserContext = React.createContext(null);

const { Provider } = UserContext;
export const UserProvider = ({ ...props }) => {
    const [state, setState] = useAggregatedState({
        me: null
    });

    const apiClient = useContext(RestApiContext);

    const getMeAsync = async () => {
        try {
            const me = await apiClient.getMeAsync();
            setState({ me });
        } catch (e) {
            setState({ me: null });
            console.debug(e);
        }
    }

    const getCurrentUserInfo = () => {
        const { me } = state;
        return me;
    }

    return (
        <Provider value={{
            state,
            getMeAsync,
            getCurrentUserInfo
        }}>
            {props.children}
        </Provider>
    );
}